import { render, staticRenderFns } from "./ManageSAPermissions.vue?vue&type=template&id=b9b615f2&"
import script from "./ManageSAPermissions.vue?vue&type=script&lang=js&"
export * from "./ManageSAPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports